import RootLayout from "layouts/RootLayout";
import clsx from "clsx";
import {liff} from "@line/liff";
import {useEffect, useState} from "react";

const LIFF_ID = process.env.REACT_APP_CONSULTING_LIFF_ID;

const initializeLIFF = async () => {
    try {
        await liff.init({liffId: LIFF_ID});
        if (!liff.isLoggedIn()) {
            liff.login();
        }
        console.log('LIFF 初始化成功');
        console.log('LIFF：', liff);
        return liff;
    } catch (error: unknown) {
        console.error('初始化 liff 時出錯：', error);
    }
};

const Consulting = () => {
    const [liffClientObject, setLiffClientObject] = useState(null);
    const [isYesButtonDisabled, setIsYesButtonDisabled] = useState(false);
    const initialize = async () => {
        const liffObject = await initializeLIFF();
        setLiffClientObject(liffObject);
    };

    const sendLiffWarning = async (liffClient) => {
        try {
            setIsYesButtonDisabled(true);
            const profile = await liffClient.getProfile();
            const display = profile.displayName || 'Guest'; // 防止 displayName 为空


            // 透過 LIFF SDK 發送訊息給用戶
            await liffClient.sendMessages([{
                type: 'text',
                text: `有出現警訊表徵`
            }]);

            // add for send warning message to line
            // const scriptUrl = process.env.REACT_APP_WARNING_URL;
            const scriptUrl = 'https://script.google.com/macros/s/AKfycbyhEC-UPWvxcrewwRc_WFh2h1EriTXHtpZf7A5CjZz3VBq8W69poVuEJn1zps6MsKl6/exec'; // prod
            // const scriptUrl = 'https://script.google.com/macros/s/AKfycbysZj-uCI-6RSjzPinH2Z4SUdVGVcHyfP1g4jCda70j378xYhOuuERWqPk5p6c1xrKW/exec'; // dev
            fetch(scriptUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'text/plain;charset=utf-8',
                },
                body: JSON.stringify({
                    line_name: display
                })
            }).catch((error) => {
                // 顯示錯誤訊息提示，跳出訊息內容：因網路問題，無法送出諮詢，請稍後再試或有緊急需求請撥打119
                alert('因網路問題，無法送出諮詢，請稍後再試或有緊急需求請撥打119!!');
            });

            // 關閉 LIFF SDK
            liffClient.closeWindow();
            setIsYesButtonDisabled(false);
        } catch (error: unknown) {
            console.error('Error initializing liff or sending message: ', error);
        }
    }
    useEffect(() => {
        initialize();
    }, []);
    const handleNo = () => {
        window.location.href = "https://liff.line.me/" + process.env.REACT_APP_FORM_LIFF_ID;
        // navigate('/consultForm');
    };

    const handleYes = async () => {
        if (liffClientObject) {
            await sendLiffWarning(liffClientObject);
        } else {
            console.error('LIFF client object is not initialized');
        }
    }

    return (
        <RootLayout title="我要諮詢">
            <div className="p-6 flex flex-col justify-center items-center">
                <div className="pb-8 text-xl tracking-wide">
                    在開始進行諮詢服務前，請問被諮詢的孩童目前是否有出現下列【就醫警訊】或【緊急就醫條件】的任何一項?
                </div>
                <div className="w-full">
                    <img src="/img/119-title.png" alt="描述" className="pb-8"/>
                    <img src="/img/119.png" alt="描述" className="w-full"/>
                </div>
                <div className="pt-2 w-4/5 flex flex-col justify-center items-center space-y-5 ">
                    <button
                        name="yesButton"
                        className="h-10 w-full bg-[#FF6666] rounded-[20px] text-white" disabled={isYesButtonDisabled}
                        onClick={handleYes}
                    >
                        {isYesButtonDisabled ? '建議前往就醫' : '是'}
                    </button>
                    <button
                        className={clsx(
                            "h-10 w-full bg-[#FCE4EC]",
                            "border-[1px] border-[#FF6666] rounded-[20px]"
                        )}
                        onClick={handleNo}
                    >
                        否
                    </button>
                </div>
            </div>
        </RootLayout>
    );
};

export default Consulting;
